<template>
  <div class="home-page">
    <div class="header-bgfff bgfff">
      <Header></Header>
      <div class="nav ac">
        <div class="back" @click="back" >
          <img width="40" src="../../static/images/back2.png" />
        </div>
        <span>
        {{info.task_name_text}}
        </span>
      </div>
    </div>

    <transition name="fade" mode="out-in">
      <div :key="test_num">
        <main class="home-content learning-content" >
          <h2 class="ac mt30 font-family">{{infoTest[test_num].title}}</h2>
          <div class="ciyu disflex mt50" style="justify-content: space-around;" v-if="infoTest[test_num].questionType==1">
            <div class="ciyu-li" :class="{'wenhao':item==''}" v-for="(item,index) in infoTest[test_num].questionContent">
              {{item}}
            </div>
          </div>
          <div class="ciyu disflex mt50" v-if="infoTest[test_num].questionType==2">
            <img style="width:100%" :src="infoTest[test_num].resUrl" />
          </div>
          <div class="ciyu disflex mt50" v-if="infoTest[test_num].questionType==3">
        <span class="" @click="playAudio('audioAnswer')" :class="{ 'image-grow': activeAudio2 === 'audioAnswer' }"  style="justify-content: center;">
          <img style="width:200px;border-radius: 60px;" src="../../static/images/ting.png" />
        </span>
            <audio
              ref="audioAnswer"
              :src="infoTest[test_num].resUrl"
              playsinline
              webkit-playsinline
              style="display: none;"
            ></audio>
          </div>
          <div class="test-answerList disflex mt50">
            <div class="ans-li" v-for="(item,index) in infoTest[test_num].answerList" @click="getNextAnswer(item)">
              <div class="character-display">{{item.answerContent}}</div>
              <div class="ans-sb" v-if="showFeedback && isActive==item.id">
                <img :src="isDui?'../../static/images/dui.png':'../../static/images/cuo.png'">
              </div>
            </div>
          </div>
          <div style="margin-top: 30px;text-align: center">
            <span>{{$t('test_tip')}}</span>
          </div>
          <div class="progress fw7 fs27 mt50 ac">{{ test_num + 1 }} of {{ test_num_all }}</div>
        </main>

      </div>
    </transition>
    <Dialog ref="buyDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
      <div class="invited-c ac" slot="mdBox" style="">
        <div class="invited-l">
          <h2 class="ac mt30 font-family " style="color: #2a2d5a">  {{ levelContent.title }}</h2>
          <img style="width: 50%; margin: 50px 0 -80px;" :src="levelContent.img">
          <div class="" style="margin-top: 120px;font-size: 24px;">
            <div class="" style="width:90%;margin: 10px auto 30px;">{{ levelContent.tip }}</div>
          </div>
         <div class="sure_btn" @click="closeBuyPopup">
           <button class=" btn6 font-family mt20" style="line-height: 103px;color: #fff;font-size: 30px;" >{{ levelContent.btn }}</button>
         </div>
        </div>
      </div>
    </Dialog>


  </div>
</template>

<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
  components: {
    Header,
    Dialog
  },
  data() {
    return {
      isShow: null,
      info: {},
      infoStudy: [],
      infoTest: [{}],
      questionList: [],
      study_num: 0,
      test_num: 0,
      id: {},
      gameList: null,
      isFirstLoad: true,
      study_num_all: 0,
      test_num_all: 0,
      activeAudio: null,
      activeAudio2:null,
      isDui:null,
      isActive:'',
      question_id:'',
      isTest:true,
      showFeedback: false,
      test_id: "",
      test_level:1,

    }
  },
  computed: {
    levelContent() {
      // 根据 test_level 返回对应内容
      const levelMap = {
        1: {
          title: this.$t('level_1_title'),
          img: require('../../static/images/level_1.png'),
          tip: this.$t('level_1_tip'),
          btn: this.$t('level_1_btn')
        },
        2: {
          title: this.$t('level_2_title'),
          img: require('../../static/images/level_2.png'),
          tip: this.$t('level_2_tip'),
          btn: this.$t('level_2_btn')
        },
        3: {
          title: this.$t('level_3_title'),
          img: require('../../static/images/level_3.png'),
          tip: this.$t('level_3_tip'),
          btn: this.$t('level_3_btn')
        }
      };
      return levelMap[this.test_level] || levelMap[1];
    }
  },

  created() {
    this.id = this.$route.query.id
    this.getList();
  },
  mounted() {
    document.addEventListener('click', this.handleFirstInteraction, { once: true });
  },
  methods: {
    back(){
      this.$router.push({path:'/',query: {}});
    },
    playAudio(type){
      if (this.$refs.audioAnswer) {
        this.activeAudio2 = type;
        this.$refs.audioAnswer.pause();
        this.$refs.audioAnswer.currentTime = 0;
        this.$refs.audioAnswer.play().catch(e => console.log("播放失败:", e));
        this.$refs.audioAnswer.onended = () => {
          this.activeAudio2 = null;
        };
      }else {
        console.log("播放失败")
      }
    },
    getNextAnswer(item){
      if(this.showFeedback) return;
      let that = this
      that.isDui = null
      that.showFeedback = false
      if(that.question_id == item.question_id){
        return;
      }
      let data = {
        "question_id":item.question_id,
        "answer_id":item.id,
        "test_id":that.test_id,
      }
      that.question_id = item.question_id
      that.isActive = item.id
      that.$api.post('/api/level/submit_answer', data, r => {
        that.$parent.returnCode(r,function(){
          that.isDui = r.data.result
          that.showFeedback = true
          setTimeout(() => {
              that.isDui = null
              that.isActive = ''
              that.question_id = ''
              that.showFeedback = false

              // 是否是最后一题
              if (that.test_num + 1 >= that.test_num_all) {
                console.log('显示评级');
                that.getResultLevel()
              } else {
                that.test_num++;
                // 如果下一题是听力题 → 自动播放
                if (that.infoTest[that.test_num].questionType === 3) {
                  that.playAudio('audioAnswer');
                }
              }
          }, 1000);
        })
      })
    },
    getResultLevel(){
      let that = this
      that.$parent.loadModal(true);
      let data = {
        "test_id":that.test_id,
      }
      that.$api.post('/api/level/get_test_result', data,r =>{
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          that.test_level = r.data.test_level
            //显示评级弹窗
          that.$refs.buyDialog.showMaskFun();
        });
      })
    },

    handleFirstInteraction() {
      if (this.isFirstLoad && this.infoStudy.length > 0) {
        this.initAudioPlayback();
        this.isFirstLoad = false;
      }
    },
    clearAudioEventListeners() {
      if (this.$refs.audioWord) this.$refs.audioWord.onended = null;
      if (this.$refs.audioWords) this.$refs.audioWords.onended = null;
      if (this.$refs.audioSentence) this.$refs.audioSentence.onended = null;
    },
    pauseAllAudios() {
      this.activeAudio = null;
      ['audioWord', 'audioWords', 'audioSentence'].forEach(ref => {
        if (this.$refs[ref]) {
          this.$refs[ref].pause();
          this.$refs[ref].currentTime = 0;
        }
      });
    },
    initAudioPlayback() {
      this.pauseAllAudios();
      this.setupSequentialPlayback();
      this.activeAudio = 'word';
      this.$nextTick(() => {
        if (this.$refs.audioWord) {
          this.$refs.audioWord.play().catch(e => console.log("自动播放被阻止"));
        }
      });
    },
    setupSequentialPlayback() {
      this.clearAudioEventListeners();
      if (this.$refs.audioWord) {
        this.$refs.audioWord.onended = () => {
          this.activeAudio = 'words';
          if (this.$refs.audioWords) {
            this.$refs.audioWords.play();
            this.$refs.audioWords.onended = () => {
              this.activeAudio = 'sentence';
              if (this.$refs.audioSentence) {
                this.$refs.audioSentence.play();
                this.$refs.audioSentence.onended = () => {
                  this.activeAudio = null;
                };
              }
            };
          }
        };
      }
    },
    playWordsAudio() {
      this.activeAudio = 'words';
      if (this.$refs.audioWords) {
        this.$refs.audioWords.play();
        this.$refs.audioWords.onended = () => {
          this.activeAudio = null;
        };
      }
    },
    playSentenceAudio() {
      this.activeAudio = 'sentence';
      if (this.$refs.audioSentence) {
        this.$refs.audioSentence.play();
        this.$refs.audioSentence.onended = () => {
          this.activeAudio = null;
        };
      }
    },
    getList() {
      let that = this
      let data = {
        "id": this.id
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/level/question', data, r => {
        that.$parent.returnCode(r,function(){
          that.info = r.data
          that.test_id = r.data.test_id
          that.infoStudy = r.data.study || []
          that.infoTest = r.data.test || []
          that.study_num_all = r.data.study_num || 0
          that.test_num_all = r.data.test_num || 0
          that.$parent.loadModal(false);

          if (that.infoStudy.length > 0) {
            that.$nextTick(() => {
              that.initAudioPlayback();
            });
          }
          that.isFirstLoad = true;
        })
      })
    },
    closeBuyPopup(){
      this.$refs.buyDialog.closeMask();
      this.$router.push({path:'/',query: {}});
    },
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}


.checkmark {
  cursor: pointer;
  margin-left: 8px;
}
.checkmark img {
  width: 30px;
  height: 30px;
  vertical-align: middle;
  transition: transform 0.2s ease;
}
.divider {
  cursor: pointer;
}
.loading-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 18px;
}

.image-grow {
  animation: pulse 0.5s infinite alternate;
}
@keyframes pulse {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.2);
  }
}

.sure_btn{
  display: block;
  width: 70%;           /* 按钮宽度，手机上也合适 */
  max-width: 600px;     /* 最大宽度 */
  margin: 20px auto 0;  /* 居中并有间距 */
  padding: 12px 0;      /* 内边距控制高度 */
  font-size: 18px;      /* 字体大小适中 */
  line-height: normal;  /* 去掉原来的103px */
  background: url('../../static/images/level_button.png') no-repeat center;
  background-size: contain;  /* 图片自适应容器 */
  text-align: center;
  color: #fff;
  text-shadow: 2px 2px 0 #001d8c;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}



</style>



// WEBPACK FOOTER //
// src/page/leveltest.vue